import { SiteContainer } from "@/components/Container";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";
import React from "react";

interface SectionTitleProps {
  title: any;
  ctaText?: any;
  ctaLink?: any;
  ctatarget?: any;
  ctalabel?:any;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  titleClassname ?: string;
}

export default function SectionTitle({
  title,
  ctaText,
  ctaLink,
  ctatarget,
  ctalabel,
  as = "h2", // default is h2
  titleClassname
}: SectionTitleProps) {
  return (
    <SiteContainer className="min-h-[80px]">
      <div className="max-w-full mx-auto min-h-[70px]">
        <div
          className="flex flex-row justify-between items-center md:gap-[24px] gap-2 py-6 pb-3 md:pb-8 lg:pt-12  min-h-[50px]"
        >
          <Text
            as={as}
            id={title}
            className={`min-h-[20px] text-brandBlack text-md md:text-3xl xs:text-2xl font-bold leading-normal common-sec-title xs:max-w-full font-sans ${titleClassname}`}
          >
            {title}
          </Text>
          {ctaLink && (
            <Link
              href={ctaLink || "#"}
              target={ctatarget}
              aria-label={ctalabel || "View All"}
              prefetch={false}
              className="text-brandSecondary text-[14px] font-bold text-right hover:underline min-w-[85px] py-3 px-3"
            >
              {ctaText}
            </Link>
          )}
        </div>
      </div>
    </SiteContainer>
  );
}
